export default {
  actualSetpoint: 'Actual SP',
  actualValue: 'Actual value',
  copySetpointsFromRecipe: 'Copy setpoints from recipe',
};
